import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './TestTasksTab.css';

const API_URL = process.env.REACT_APP_API_URL || '';

function TestTaskTypesSubTab() {
  const [types, setTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [editingType, setEditingType] = useState(null);
  const [formData, setFormData] = useState({ name: '' });

  useEffect(() => {
    fetchTypes();
  }, []);

  const fetchTypes = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}/api/test-task-types`);
      setTypes(response.data);
      setError(null);
    } catch (err) {
      setError('Ошибка при загрузке типов заданий: ' + (err.response?.data?.detail || err.message));
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingType) {
        await axios.put(`${API_URL}/api/test-task-types/${editingType.id}`, formData);
      } else {
        await axios.post(`${API_URL}/api/test-task-types`, formData);
      }
      setShowForm(false);
      setEditingType(null);
      setFormData({ name: '' });
      fetchTypes();
    } catch (err) {
      setError('Ошибка при сохранении типа задания: ' + (err.response?.data?.detail || err.message));
    }
  };

  const handleEdit = (type) => {
    setEditingType(type);
    setFormData({ name: type.name });
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Вы уверены, что хотите удалить этот тип задания?')) {
      try {
        await axios.delete(`${API_URL}/api/test-task-types/${id}`);
        fetchTypes();
      } catch (err) {
        setError('Ошибка при удалении типа задания: ' + (err.response?.data?.detail || err.message));
      }
    }
  };

  const handleCancel = () => {
    setShowForm(false);
    setEditingType(null);
    setFormData({ name: '' });
  };

  if (loading) {
    return <div className="loading">Загрузка...</div>;
  }

  return (
    <div className="test-task-types-subtab">
      <div className="tab-header">
        <h2>Типы тестовых заданий</h2>
        {!showForm && (
          <button className="btn btn-primary" onClick={() => setShowForm(true)}>
            + Добавить тип
          </button>
        )}
      </div>

      {error && <div className="error-message">{error}</div>}

      {showForm && (
        <div className="form-container">
          <h3>{editingType ? 'Редактировать тип задания' : 'Добавить новый тип задания'}</h3>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">Название типа *</label>
              <input
                type="text"
                id="name"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                required
                maxLength={255}
                placeholder="Введите название типа задания"
              />
            </div>
            <div className="form-actions">
              <button type="submit" className="btn btn-primary">
                {editingType ? 'Сохранить' : 'Создать'}
              </button>
              <button type="button" className="btn btn-secondary" onClick={handleCancel}>
                Отмена
              </button>
            </div>
          </form>
        </div>
      )}

      <div className="table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Название</th>
              <th>Дата создания</th>
              <th>Действия</th>
            </tr>
          </thead>
          <tbody>
            {types.length === 0 ? (
              <tr>
                <td colSpan="4" className="empty-state">
                  Нет типов заданий. Добавьте первый тип.
                </td>
              </tr>
            ) : (
              types.map((type) => (
                <tr key={type.id}>
                  <td>{type.id}</td>
                  <td>{type.name}</td>
                  <td>{new Date(type.created_at).toLocaleString('ru-RU')}</td>
                  <td>
                    <button
                      className="btn-icon btn-edit"
                      onClick={() => handleEdit(type)}
                      title="Редактировать"
                    >
                      ✏️
                    </button>
                    <button
                      className="btn-icon btn-delete"
                      onClick={() => handleDelete(type.id)}
                      title="Удалить"
                    >
                      ✕
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default TestTaskTypesSubTab;
